'use client';
import * as React from 'react';
import type { JSX } from 'react';

import type { ThemeProviderProps } from 'next-themes';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps): JSX.Element {
    return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
